module.exports = __webpack_public_path__ + "static/media/match-centre.ac1548c7.png";